
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { 
  Sidebar, 
  SidebarContent, 
  SidebarRail, 
  useSidebar 
} from '@/components/ui/sidebar';
import { SidebarHeader } from './sidebar/SidebarHeader';
import { SidebarNavigation } from './sidebar/SidebarNavigation';
import { SidebarFooter } from './sidebar/SidebarFooter';
import { SidebarIntegrations } from './sidebar/SidebarIntegrations';
import { useTheme } from '@/contexts/ThemeContext';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, PanelLeftOpen, PanelRightOpen } from 'lucide-react';

export function AppSidebar() {
  const { user, isAdmin } = useAuth();
  const { theme } = useTheme();
  const { state, toggleSidebar } = useSidebar();
  
  return (
    <Sidebar className="border-r border-sidebar-border bg-gradient-to-b from-[#053F3F] via-[#043535] to-[#032a2a] text-white">
      <SidebarHeader showLogo={true} />
      <SidebarContent className="bg-transparent py-2">
        <SidebarNavigation />
        
        {/* Показываем интеграции всем пользователям, но внутри компонента по-разному для админов и курьеров */}
        {user && <SidebarIntegrations />}
        
        {/* Кнопка для сворачивания/разворачивания панели */}
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleSidebar}
          className="w-full mt-4 text-white/70 hover:text-white hover:bg-tuktuk-teal/20"
          title={state === 'expanded' ? "Свернуть панель" : "Развернуть панель"}
        >
          {state === 'expanded' ? (
            <>
              <ChevronLeft className="mr-2 h-5 w-5" /> 
              <span>Свернуть панель</span>
            </>
          ) : (
            <>
              <PanelRightOpen className="h-5 w-5" />
              <span className="sr-only">Развернуть панель</span>
            </>
          )}
        </Button>
      </SidebarContent>
      <SidebarFooter />
      <SidebarRail />
    </Sidebar>
  );
}
